import { 
	FILES_ADD_KEYWORD,
	FILES_REMOVE_KEYWORD
} from 'constants/actiontypes';


export default function keywords(state = [], action) {
	switch(action.type) {
		case FILES_ADD_KEYWORD:
			const filteredKeys = [];
			action.keywords.forEach(key => {
				const tmpKey = key.trim().toLowerCase();
				if (tmpKey.length > 2 && state.indexOf(tmpKey) < 0) {
					filteredKeys.push(tmpKey);
				}
			});
			const ret = [...state, ...filteredKeys];
			return ret;
		case FILES_REMOVE_KEYWORD:
			return state.filter((keyword) => (keyword !== action.keyword.trim().toLowerCase()))
		default:
			return state;
	};
}



/** WEBPACK FOOTER **
 ** ./reducers/filekeywords.js
 **/